// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__34CFq","header":"ReportDetails_header__2sGJE","title":"ReportDetails_title__3Me64","left":"ReportDetails_left__1ExhK"};